import { render, staticRenderFns } from "./AccountSubscriptions.vue?vue&type=template&id=b0ab7962&"
import script from "./AccountSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./AccountSubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSubscriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports